<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-magnify</v-icon>
              <v-toolbar-title>View Payment</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav">
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory">
                <form data-vv-scope="paymentMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.branch }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBranchList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="paymentFormLabel.docAE" v-model="paymentForm.docAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.documentNo }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.documentNo }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.transactionDate }}</v-subheader>
                              <div class="queryValue">{{ convertDate(paymentForm.transactionDate) }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.payTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPayToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.fromBank }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFromBankList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.fund }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFundList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.accountNoSuffix }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAccountNoSuffixList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.gstIO }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstIOList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.gstStatus }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstStatusList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md3 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.gstRate }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.gstRate }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.amountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.amount }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.amount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.gstAmountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="paymentFormLabel.gstAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.gstAmount }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.gstAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.netAmountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterNetAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.netAmount }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.netAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(paymentForm.bankAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="paymentFormLabel.bankAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankAmount }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.bankAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankChargesCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(paymentForm.bankChargesCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankCharges }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.bankCharges }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankTotalAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(paymentForm.bankTotalAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankTotalAmount }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.bankTotalAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankTotalLocalCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBankTotalLocalCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox
                                color="primary"
                                :label="paymentFormLabel.bankTotalLocalAE"
                                v-model="paymentForm.bankTotalLocalAE"
                                disabled
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.bankTotalLocal }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.bankTotalLocal }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.chequeNo }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.chequeNo }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm8 lg8>
                              <v-checkbox color="primary" :label="paymentFormLabel.prtCheque" v-model="paymentForm.prtCheque" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.createdBy + ' on ' + paymentForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.modifiedBy + ' on ' + paymentForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional">
                <form data-vv-scope="paymentOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.printDocument }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPrintDocumentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.addressTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.policyNo }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.policyNo }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.companyName }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.companyName }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.docAddress1 }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.docAddress1 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.docAddress2 }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.docAddress2 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.docAddress3 }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.docAddress3 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.docAddress4 }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.docAddress4 }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.postalCode }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.postalCode }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.details }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.details }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.statementRef }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.statementRef }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.department }}</v-subheader>
                              <div class="queryValue" v-for="item in filterDepartmentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.insuredName }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.insuredName }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.claimNo }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.claimNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.gstRegNo }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.gstRegNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.taxInvoiceNo }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.taxInvoiceNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>

            <v-flex xs12>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-flex>
            <!-- CBO Added: Oct-05-2020 Comments -->
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg12 xs12 order-lg1 order-xs2>
                  <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType" :mode="'query'"></common-comments>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when review payment.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { paymentListMixin } from '@/mixins/accounting/payment/paymentListMixin'
import { paymentFilterMixin } from '@/mixins/accounting/payment/paymentFilterMixin'
import { paymentAjaxMixin } from '@/mixins/accounting/payment/paymentAjaxMixin'
import { paymentViewMixin } from '@/mixins/accounting/payment/paymentViewMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'
import CommonComments from '@/components/core/accounting/CommonComments'

export default {
  data() {
    return {
      // createPaymentTabs: ['Mandatory', 'Optional'],
      tabNav: 0,
      actionLabel: {
        cancel: 'Cancel'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      miscacctparams: [],
      cashbooks: [],
      departments: [],
      checkTabData: false,
      loading: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      isMandatory: true,
      isOptional: false,
      accounts: [],
      accountdata: {},
      banks: [],
      bankdata: {},
      acctnosuffixes: [],
      acctnosuffixdata: {},
      amountcurrencies: [],
      amountcurrencydata: {},
      trandaterange: {},
      gstStatuses: [],
      funds: [],
      currencies: [],
      gstrate: '0.00',
      chequeNoForm: null,
      promptConfirmation: false,
      isExistChequeNo: false,
      actionName: null,
      currencyrate: {}
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    paymentData() {
      return this.$store.state.payment.paymentData
    },
    displayErrorDialog() {
      return this.messages
    },
    filterBranchList() {
      return this.branches.filter((list) => {
        return list.value === this.paymentForm.branch
      })
    },
    filterPayToList() {
      return this.accounts.filter((list) => {
        return list.value === this.paymentForm.payTo
      })
    },
    filterFromBankList() {
      return this.banks.filter((list) => {
        return list.value === this.paymentForm.fromBank
      })
    },
    filterAccountNoSuffixList() {
      return this.acctnosuffixes.filter((list) => {
        return list.value === this.paymentForm.accountNoSuffix
      })
    },
    filterGstIOList() {
      return this.gstIO.filter((list) => {
        return list.value === this.paymentForm.gstIO
      })
    },
    filterGstStatusList() {
      return this.gstStatuses.filter((list) => {
        return list.value === this.paymentForm.gstStatus
      })
    },
    filterAmountCurrList() {
      return this.amountcurrencies.filter((list) => {
        return list.value === this.paymentForm.amountCurr
      })
    },
    filterGstAmountCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.paymentForm.gstAmountCurr
      })
    },
    filterNetAmountCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.paymentForm.netAmountCurr
      })
    },
    filterBankTotalLocalCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.paymentForm.bankTotalLocalCurr
      })
    },
    filterPrintDocumentList() {
      return this.printDocOpts.filter((list) => {
        return list.value === this.paymentForm.printDocument
      })
    },
    filterAddressToList() {
      return this.addressToOpts.filter((list) => {
        return list.value === this.paymentForm.addressTo
      })
    },
    filterDepartmentList() {
      return this.departments.filter((list) => {
        return list.value === this.paymentForm.department
      })
    },
    filterFundList() {
      return this.funds.filter((list) => {
        return list.value === this.paymentForm.fund
      })
    },
    apiURI() {
      return this.$store.state.payment.menu
    },
    commentRefNo() {
      const data = this.$store.state.payment.paymentData
      return data.accountNo + data.documentNo + data.fund + data.suffix + data.branch + data.type
    },
    commentTranType() {
      return this.$store.state.payment.paymentData.type
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('paymentInit')])
      this.getCommonData('miscacctparams', 'cash')
      this.getCommonData('miscacctparams').then((result) => {
        this.paymentForm.printDocument = this.miscacctparams.defIlnrcpt
      })
      this.getChequeNoForm()
      this.fetchBranch()
      this.fetchFund()
      this.fetchCurrency()
      this.fetchCashBook()
      this.fetchDepartment()
      this.fetchAccount()
      this.fetchBank()
      this.fetchAcctNoSfx()
      this.fetchAmountCurrency()
      this.fetchGstStatus()
      await Promise.all([this.performReview()])
    },
    filterCurrList(curr) {
      const data = this.currencies.find(list => list.value === curr)
      return data ? data.label : ''
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    doMandatory(tabId) {
      if (this.isMandatory === false) {
        this.isMandatory = true
        this.isOptional = false
        this.validStatus.optional = true
        this.validStatus.mandatory = true
        this.tabNav = tabId
      }
    },
    doOptional(tabId) {
      if (this.isOptional === false) {
        this.isMandatory = false
        this.isOptional = true
        this.validStatus.mandatory = true
        this.validStatus.optional = true
        this.tabNav = tabId
      }
    },
    doCancel() {
      this.$router.push({ name: 'payment' }).catch(() => {})
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, paymentListMixin, paymentAjaxMixin, paymentFilterMixin, paymentViewMixin, commonAjaxMixin],
  components: {
    CommonComments
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
